import Profile from '../hooks/Profile/Profile';
import Header from '../components/ProfileCard/Header';
import PointAndLevel from '../components/ProfileCard/PointAndLevel';
import Insignias from '../components/ProfileCard/Insignias';
import ModalProfile from '../components/ProfileCard/ModalProfile';
import DeleteModal from '../../contacts/utils/DeleteModal';
import AsyncButton from '../../../shared/Loading/AsyncButton';

const BONDA_DELETE_WARNING = 'Al eliminar este usuario, el correo quedara asociado a la identificacion actual en la plataforma de Bonda y no se podra crear otro usuario con el mismo correo y diferente identificacion.';

const ContactProfileSection = ({ userLogin, theme, onUser, permissions, logout, losesAccess, message, onLogout, ranking, className = '' }) => {
  const vm = Profile({ userLogin, onUser, logout, losesAccess, message, onLogout });

  return (
    <div className={`profile-main-card bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden p-4 flex flex-col gap-4 ${className}`}>
      <div className="profile-main-content min-h-0 flex flex-col gap-3">
        <Header user={vm.user}/>
        <Insignias insignias={vm.insignias} />
        <PointAndLevel
            score={vm.score}
            level={vm.level}
            loading={vm.loadingPoints}
            numLevels={vm.numLevels}
            dateUpdate={vm.dateUpdate}
            getImageUrl={vm.getImageUrl}
            theme={theme}
            ranking={ranking}
        />
        <div className="profile-ranking-actions-separator" aria-hidden="true" />
        <div className="profile-actions space-y-3">
            <AsyncButton
                className="w-full bg-personalized text-white text-base py-1.5 rounded transition
                    border border-transparent
                    hover:bg-white hover:text-personalized hover:border-personalized"
                onClick={() => vm.validAction()}
            >
                Información del perfil
            </AsyncButton>
            <AsyncButton
                className="w-full bg-personalized text-white text-base py-1.5 rounded transition
                    border border-transparent hover:bg-white hover:text-personalized hover:border-personalized"
                onClick={() => vm.askDelete()}
            >
                Eliminar perfil
            </AsyncButton>
        </div>
      </div>
        <ModalProfile
          user={vm.user}
          open={vm.open}
          permissions={permissions}
          setOpen={vm.setOpen}
          closeActive={vm.closeActive}
          updateUser={vm.updateUser}
          setCloseActive={vm.setCloseActive}
          logout={logout}
          losesAccess={losesAccess}
          message={message}
        />
        <DeleteModal
            confirm={vm.confirm}
            closeActive={true}
            onClose={vm.closeDeleteModal}
            onConfirm={vm.handleConfirmDelete}
            warningMessage={BONDA_DELETE_WARNING}
        />
    </div>
  );
};

export default ContactProfileSection;
